module.exports = __webpack_public_path__ + "dc131113894217b5031000575d9de002.woff2";